import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGrid: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"grid, camera-grid"} maskId="square-filled-radius-0-stroke-1-IconGrid"><path fillRule="evenodd" clipRule="evenodd" d="M9 8H15V3H16V8H21V9H16V15H21V16H16V21H15V16H9V21H8V16H3V15H8V9H3V8H8V3H9V8ZM9 15H15V9H9V15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconGrid;
